/* Kenra Video Modal
 * Custom element wrapping a <dialog> that lazy-loads a YouTube iframe on open
 * and removes it on close so playback stops cleanly.
 *
 * Trigger any element with these attributes to open a modal:
 *   data-kenra-video-trigger
 *   data-modal-target="<modal element id>"
 *   data-youtube-id="<youtube video id>"
 */

if (!customElements.get('kenra-video-modal')) {
  class KenraVideoModal extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector('dialog');
      this.iframeWrap = this.querySelector('.kenra-video-modal__iframe-wrap');
      this.closeBtn = this.querySelector('.kenra-video-modal__close');

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }

      if (this.dialog) {
        // Click on backdrop (the dialog element itself, not its content) closes.
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        // Native Esc fires the "cancel" event before close — intercept so we can clean up.
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        });
      }
    }

    open(youtubeId) {
      if (!youtubeId || !this.dialog || !this.iframeWrap) return;

      const iframe = document.createElement('iframe');
      iframe.setAttribute(
        'src',
        'https://www.youtube.com/embed/' +
          encodeURIComponent(youtubeId) +
          '?autoplay=1&rel=0'
      );
      iframe.setAttribute('title', 'YouTube video player');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; fullscreen; gyroscope; picture-in-picture; web-share'
      );
      iframe.setAttribute('allowfullscreen', '');

      this.iframeWrap.innerHTML = '';
      this.iframeWrap.appendChild(iframe);
      this.dialog.showModal();
      document.documentElement.classList.add('kenra-video-modal-open');
    }

    close() {
      if (this.iframeWrap) this.iframeWrap.innerHTML = '';
      if (this.dialog && this.dialog.open) this.dialog.close();
      document.documentElement.classList.remove('kenra-video-modal-open');
    }
  }

  customElements.define('kenra-video-modal', KenraVideoModal);

  // Delegated trigger handler — registered inside the customElements.get() guard
  // so it only attaches once even when the snippet (and therefore this script)
  // is rendered multiple times per page.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-kenra-video-trigger]');
    if (!trigger) return;

    const modalId = trigger.getAttribute('data-modal-target');
    const youtubeId = trigger.getAttribute('data-youtube-id');
    if (!modalId || !youtubeId) return;

    const modal = document.getElementById(modalId);
    if (modal && typeof modal.open === 'function') {
      event.preventDefault();
      modal.open(youtubeId);
    }
  });
}
